function initMenuToggle() {
  const menuToggle = document.querySelector("#site_header .menu_toggle_con");
  const headerMenu = document.querySelector("#site_header .header_menu");

  if (menuToggle && headerMenu) {
    menuToggle.addEventListener("click", () => {
      menuToggle.classList.toggle("active");
      headerMenu.classList.toggle("active");
    });
  }
}

document.addEventListener("DOMContentLoaded", initMenuToggle);
document.addEventListener("shopify:section:load", initMenuToggle);

// jQuery(document).ready(function($){
//   $('#home_sec_7 .slider_con .slider_wrapper').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: false,
//     dots: false,
//     centerMode: true,
//     centerPadding: '100px', // adjust how much of the next slide shows
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           centerPadding: '20px'
//         }
//       }
//     ]
//   });
// });

jQuery(document).ready(function($){
  $('#home_hero .right_con .slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    fade: false, // set to true if you want a fade transition instead of slide
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.accordion-item');

  items.forEach(item => {
    const header = item.querySelector('.accordion-header');

    header.addEventListener('click', () => {
      const openItem = document.querySelector('.accordion-item.active');

      // Close currently open one (if different)
      if (openItem && openItem !== item) {
        openItem.classList.remove('active');
        openItem.querySelector('.accordion-content').style.maxHeight = null;
      }

      // Toggle current
      item.classList.toggle('active');
      const content = item.querySelector('.accordion-content');
      if (item.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = null;
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const header = document.getElementById('site_header');

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  });

   $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true
  });
});